export const facts = [
  { id: "ce-marked", label: "CE-marked", caption: "Medicual's published product claim." },
  { id: "since-2013", label: "Since 2013", caption: "Operating continuously since 2013." },
  { id: "resolved-online", label: "90%+", caption: "Of cases resolved online." },
  { id: "handling-time", label: "15 min", caption: "Average handling time." },
];
